<template>
  <el-card
      id="deviceSchedulesCard"
      class="box-card">
    <div
        id="deviceScheduleHeaderContainer"
        slot="header"
        class="clearfix">
      <span class="header-item">{{ $t('device.schedules') }}</span>
      <div class="text-link__container">
        <TextLink @click="showHelp()">
          Need help adding a schedule?
        </TextLink>
      </div>
    </div>
    <schedules-tabs
        slot="default"
        :device-name="deviceName" />
  </el-card>
</template>

<script>
import SchedulesTabs from "./SchedulesTabs";
import TextLink from "@/NewUI/components/core/TextLink";

export default {
  name: "Schedules",
  components: {
    SchedulesTabs,
    TextLink,
  },
  props: {
    deviceName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      centralRingUrl:
        "https://ring.shelf.io/read/bfa23b2a-dcfc-498f-95e7-038dd8063976",
    };
  },
  methods: {
    showHelp() {
      window.open(this.centralRingUrl, "_blank");
    },
  },
};
</script>

<style>
.text-link__container {
  display: flex;
}
</style>

<style lang="scss">
@import "@/assets/scss/newui/card.scss";

/* Removes card body margins*/
#deviceSchedulesCard > div.el-card__body {
  @include card__body-margins();
}

/* Styles for each item within the header */
#deviceScheduleHeaderContainer span.header-item {
  @include heading__small-medium();
  margin: 0;
}

/* Card title header container */
#deviceSchedulesCard .el-card__header {
  @include card__header();
}

#deviceScheduleHeaderContainer {
  @include card__header-container();
}
</style>
